<template>
    <section>
        <br>
        <div class="container" style="overflow-x: auto ; padding-left:10px; margin-left:10px">
            <nav class="level is-mobile">
                <div class="level-left">
                    <div class="level-item">
                        <b-button type="is-success" icon-left="image-search"  outlined @click="openIMRHome"   :disabled="countIMR===0" v-if="OPDSelected"> Images <b-tag  type="is-info" rounded > {{countIMR}}  </b-tag></b-button>
                    </div>
                    <div class="level-item">
                        <b-button type="is-success" icon-left="stethoscope"  outlined @click="openHistoryFinance"    v-if="OPDSelected"> History of Medicine </b-button>
                    </div>
                    <div class="level-item">
                        <b-button type="is-success" icon-left="magnify"  outlined @click="searchNewOPD"  > Search New OPD</b-button>
                    </div>

                    <!-- <div class="level-item">
                        <b-button type="is-success" icon-left="magnify"  outlined @click="showSearchLabbyLabID"  > Search LAB By LAB ID</b-button>
                    </div>



                    <div class="level-item">
                        <b-button type="is-success" icon-left="magnify"  outlined @click="showSearchSomeTextInLab"  > Search Some Text Find in LAB Nonautomate Result</b-button>
                    </div> -->
                </div>
             </nav>
        </div>
     <hr>
        <div class="container" style="overflow-x: auto ; padding-left:10px; margin-left:10px">
            <HeaderDecorate :showLabNo=false />
        </div>
     <hr>
 







     <hr>

        <b-tabs position="is-left"
                size="is-medium"
                type="is-boxed"

                v-model="tabOPDSpace"

                @input="inputTabOPDSpace"
                >
            <b-tab-item >
                <template slot="header">
                    <b-icon icon="table-large"></b-icon>
<!--                    <span>List of Lab <b-tag  type="is-info" rounded v-if="listOfLabOPDTarget_ModifiedForDisplay.length>0"> {{ listOfLabOPDTarget_ModifiedForDisplay.length }}  </b-tag> </span>-->
                    <span>List of Lab   <b-tag  type="is-info" rounded v-if="listoflabopdtarget_v2.length>0"> {{ listoflabopdtarget_v2.length }}  </b-tag> </span>
                </template>
                <ListOfLabEachOPD  ref="ListOfLabEachOPD" @viewLabEmitBy_ListOfLabEachOPD="viewLabEmitBy_ListOfLabEachOPD"/>

<!--                <nav class="level">-->
<!--                    <div class="level-left">-->
<!--                        <div class="level-item">-->
<!--                            <b-field label="Doc. Kind Filter" v-if="listOfLabOPDTarget_ModifiedForDisplay.length>0">-->
<!--                                <b-select placeholder="Select a name" v-model="docKindSelected">-->
<!--                                    <option-->
<!--                                            v-for="dockind in docKind"-->
<!--                                            :value="dockind.name"-->
<!--                                            :key="dockind.id">-->
<!--                                        {{ dockind.name }}-->
<!--                                    </option>-->
<!--                                </b-select>-->
<!--                                <b-tooltip label="Clear Doc. Kind" position="is-top">-->
<!--                                    <p class="control">-->
<!--                                        <b-button type="is-success" icon-left="close"  outlined   @click=" docKindSelected = '' " />-->
<!--                                    </p>-->
<!--                                </b-tooltip>-->
<!--                            </b-field>-->
<!--                        </div>-->
<!--                       -->

<!--                    </div>-->
<!--                    <div class="level-right">-->
<!-- -->
<!--                    </div>-->
<!--                </nav>-->
<!--                <div class="box" >-->
<!--                <b-table-->
<!--                         :data="isEmpty ? [] : listOfLabOPDTarget_ModifiedForDisplayByFilter"-->
<!--                         :bordered="isBordered"-->
<!--                         :striped="isStriped"-->
<!--                         :narrowed="isNarrowed"-->
<!--                         :hoverable="isHoverable"-->
<!--                         :loading="isLoading"-->
<!--                         :focusable="isFocusable"-->
<!--                         :mobile-cards="hasMobileCards"-->
<!--                         paginated-->
<!--                         pagination-size="is-medium"-->
<!--                         pagination-position="bottom"-->
<!--                         :current-page.sync="currentPage"-->
<!--                         :per-page="perPage" >-->


<!--                        <b-table-column  label="Lab No."  centered v-slot="props">-->
<!--                            <b-button type="is-info"  @click="viewLab(props.row.idlab,props.row.kind)">{{ props.row.idlab }}</b-button>-->
<!--                        </b-table-column>-->


<!--                        <b-table-column field="kind" label="Kind"   v-slot="props">-->
<!--                                            <span class="tag is-warning"  >-->
<!--                                                         {{props.row.kind}}-->
<!--                                            </span>-->
<!--                        </b-table-column>-->

<!--                        <b-table-column field="datereq" label="DateTime Req."  v-slot="props">-->

<!--                                             <span class="tag"  v-if="props.row.datereq.length>0" style="color: teal" >-->
<!--                                                      {{ props.row.datereq }} - {{ props.row.timereq }}-->
<!--                                             </span>-->
<!--                            <p v-else></p>-->

<!--                        </b-table-column>-->
<!--                        <b-table-column field="id" label="Req. By"   v-slot="props">-->
<!--                            {{ props.row.reqby }}-->
<!--                        </b-table-column>-->

<!--                        <b-table-column   label="DateTime Accept" v-slot="props" >-->
<!--                                             <span class="tag "  v-if="props.row.dateaccept.length>0" style="color: teal" >-->
<!--                                                       {{ props.row.dateaccept }} - {{ props.row.timeaccept }}-->
<!--                                            </span>-->
<!--                            <p v-else></p>-->
<!--                        </b-table-column>-->


<!--                        <b-table-column   label="DateTime Cancel"  v-slot="props" >-->
<!--                                            <span class="tag " v-if="props.row.datecancle.length>0" style="color: red" >-->
<!--                                                      {{ props.row.datecancle }} - {{ props.row.timecancle }}-->
<!--                                            </span>-->
<!--                            <p v-else></p>-->

<!--                        </b-table-column>-->
<!--                        <b-table-column   label="DateTime Reject"  v-slot="props" >-->
<!--                                            <span class="tag "  v-if="props.row.datereject.length>0" style="color: red">-->
<!--                                                       {{ props.row.datereject }} - {{ props.row.datereject }}-->
<!--                                            </span>-->
<!--                            <p v-else></p>-->

<!--                        </b-table-column>-->
<!--                        <b-table-column   label="DateTime Result" v-slot="props" >-->
<!--                                             <span class="tag "  v-if="props.row.dateresult.length>0" style="color: green">-->
<!--                                                       {{ props.row.dateresult }} - {{ props.row.timeresult }}-->
<!--                                            </span>-->
<!--                            <p v-else></p>-->
<!--                        </b-table-column>-->

<!--                        <b-table-column  field="status" label="Status" centered v-slot="props">-->
<!--                                                       <span class="tag"  :class="labStatusColor(props.row.status )" >-->
<!--                                                         {{props.row.status}}-->
<!--                                                       </span>-->
<!--                        </b-table-column>-->



<!--                    <template slot="empty">-->
<!--                        <section class="section">-->
<!--                            <div class="content has-text-grey has-text-centered">-->
<!--                                <p>-->
<!--                                    <b-icon-->
<!--                                            icon="emoticon-sad"-->
<!--                                            size="is-large">-->
<!--                                    </b-icon>-->
<!--                                </p>-->
<!--                                <p>Nothing here.</p>-->
<!--                            </div>-->
<!--                        </section>-->
<!--                    </template>-->
<!--                </b-table>-->
<!--                </div>-->








            </b-tab-item>

            <b-tab-item>
                <template slot="header">
                    <b-icon icon="file-document"></b-icon>
                    <span> Detail LAB <b-tag  type="is-info" rounded v-if="IDLABSelected.idlab"> {{ IDLABSelected.idlab }} </b-tag> </span>
                </template>

<!--                :disabled="isBtnRefreshCBC"-->
<!--            for All LAB Kind   file-document-box-outline -->

                  <b-button type="is-success" icon-left="refresh"  outlined @click="viewSpecLab" ref="btnRefreshLN"  :disabled="!IDLABSelected.idlab" >Refresh LN {{ IDLABSelected.idlab  }}</b-button>

                  <b-tooltip label="Copy to clipboard">
                       <b-button  
                        v-clipboard:copy="IDLABSelected.idlab"
                        @click="clickCopyIntoClipboard(IDLABSelected.idlab)"
                        icon-left="content-copy" />
                  </b-tooltip>
                   
<!--            Cyto    -->
<!--                {{ userRoleFind(1) }}{{ userRoleFind(2) }} {{ userRoleFind(3) }}{{ userRoleFind(4) }}{{ userRoleFind(5) }}-->

                &nbsp;

<!--                <h1  v-if=" dataCytoSpecLN ">    {{dataCytoSpecLN}} {{user_id}} {{userIsAdmin}}</h1>-->

                <hr>
<!--            b-field for CBC -->


<!--                box CBC -->
                <!-- <CBC_DetailEachID   :dataCBCSpecLN="dataCBCSpecLN"
                                    :dataLabParamsMaster="dataLabParamsMaster"
                                    :dataLabParamsMasterUA="dataLabParamsMasterUA"
                                    :unitCBC="unitCBC"
                                    :IDLABSelected="IDLABSelected"
                                    v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'CBC'   "/> -->
                <CBC_DetailEachID_V2   
                                    :dataCBCSpecLN="dataCBCSpecLN"
                                    :IDLABSelected="IDLABSelected"
                                    @trigRequestRefreshDataCBC="viewSpecLab"
                                    v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'CBC' &&  dataCBCSpecLN && dataCBCSpecLN.version == 2   "/>


                <CBC_DetailEachID_V3
                    :dataCBCSpecLN = "dataCBCSpecLN"
                    :IDLABSelected="IDLABSelected"
                    :useGoToList = "false"
                    v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'CBC' && dataCBCSpecLN && dataCBCSpecLN.version == 3  "/>



<!--                box Cyto -->
                <Cytology_EachID  :dataCytoSpecLN="dataCytoSpecLN"
                                  :isCytoShowing="isCytoShowing"
                                  @close="closeEditDocLAB"
                                  @trigForPlusUpdate="trigForPlusUpdate"
                                  :IDLABSelected="IDLABSelected"
                                  v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'CYTOLOGY' "/>
<!--                box Biopsy -->
                <Biopsy_EachID  :dataBiopsySpecLN="dataBiopsySpecLN"
                                @close="closeEditDocLAB"
                                @trigForPlusUpdate="trigForPlusUpdate"
                                :IDLABSelected="IDLABSelected"
                                v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'BIOPSY' " />


<!--                box Necropsy -->
                <Necropsy_EachID  :dataNecropsySpecLN="dataNecropsySpecLN"
                                @close="closeEditDocLAB"
                                @trigForPlusUpdate="trigForPlusUpdate"
                                :IDLABSelected="IDLABSelected"
                                v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'NECROPSY' " />



 <!--                box PCR -->
                <PCR_EachID
                                :dataPCRSpecLN="dataPCRSpecLN"
                                :IDLABSelected="IDLABSelected"
                                @trigForPlusUpdate="trigForPlusUpdate"
                                v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'PCR' " />
<!--                 box Bact   -->
                <Bact_EachID   :dataBACTSpecLN="dataBACTSpecLN"
                               :IDLABSelected="IDLABSelected"
                                @trigForPlusUpdate="trigForPlusUpdate"
                                v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'BACTERIAL' "/>
<!--                 box ORGA   -->
                <Orga_EachID   :dataORGASpecLN="dataORGASpecLN"
                               :IDLABSelected="IDLABSelected"
                               @trigForPlusUpdate="trigForPlusUpdate"
                               v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'ORGANISM' "/>


<!--                 box Parasite   -->
                <PARA_EachID   :dataPARASpecLN="dataPARASpecLN"
                               :IDLABSelected="IDLABSelected"
                                @trigForPlusUpdate="trigForPlusUpdate"
                                v-if="IDLABSelected.idlab && IDLABSelected.kind.toUpperCase()  === 'PARASITE' "/>


            </b-tab-item>

          <b-tab-item label="Table Data(ข้อมูลตั้งแต่วันที่ 2/12/2025)" icon="test-tube"  >
            <CBC_Table_V3 />
          </b-tab-item>
            <b-tab-item label="Table Compare 1" icon="test-tube"  >

                <TableAndChartCBC 
                  :cusNoToChild="cusNoToChild.cus0"
                  />
               



            </b-tab-item>

<!--            <b-tab-item label="Table Compare 2" icon="test-tube" style=" overflow-x: scroll; overflow-y: scroll;">-->



<!--                 -->
<!--                 <TableAndChartCBC -->
<!--                  :cusNoToChild="cusNoToChild.cus1"-->
<!--                  />-->


<!--           -->
<!--            </b-tab-item>-->

<!--            <b-tab-item label="Table Compare 3" icon="test-tube" style=" overflow-x: scroll; overflow-y: scroll;">-->

<!--                 <TableAndChartCBC -->
<!--                  :cusNoToChild="cusNoToChild.cus2"-->
<!--                  />-->


<!-- -->
<!--            </b-tab-item>-->


















            <!-- <b-tab-item label="Chart" icon="chart-line" >
                <b-collapse :open="dataRawCBC.length>0" aria-id="contentIdForA11y1">
                    <button
                            class="button"
                            slot="trigger"
                            aria-controls="contentIdForA11y1"
                            :disabled="dataRawCBC.length===0">Set Params to display  &nbsp;<b-icon icon="menu-down"></b-icon></button>


                    <div class="notification">
                        <div class="content">
                            <div class="columns">
                                <div class="column ">
                                     <b>Selected X Axis ( {{ chartXAxis.length }} ) </b>
                                     <b-tooltip label="Delete All"  type="is-danger" ><b-button type="is-danger" icon-right="delete" v-show="chartXAxis.length>0" @click="clearchartXAxis" /></b-tooltip>
                                    <b-taglist>
                                        <b-tag type="is-primary" size="is-medium" v-for="dateTimeByIdlab in displayDateTimeByIdlabInObj" :key="dateTimeByIdlab.idlab">
                                            <span  class="is-size-7">{{dateTimeByIdlab.idlab}}</span>&nbsp;
                                            <b-tag rounded style="margin-top: 10px"> {{dateTimeByIdlab.date_req}} - {{dateTimeByIdlab.time_req}} </b-tag>

                                        </b-tag>
                                    </b-taglist>
                                    <b-dropdown
                                            v-model="chartXAxis"
                                            multiple
                                    >
                                        <button class="button " type="button" slot="trigger">
                                            <span>Select X Axis  ({{ chartXAxis.length }})</span>
                                            <b-icon icon="menu-down"></b-icon>
                                        </button>

                                        <b-dropdown-item  :value="dataRawCBCData.idlab" v-for="dataRawCBCData in formatDatRawCBC " :key="dataRawCBCData.idlab">
                                            LabNo : <span class="is-size-7"   >{{dataRawCBCData.idlab}}   </span>&nbsp;
                                            Date :<span class="is-size-7"  > {{ dataRawCBCData.date_req }}  </span> - <span class="is-size-7"   > {{ dataRawCBCData.time_req }}</span>
                                        </b-dropdown-item>

                                    </b-dropdown>
                                </div>
                                <div class="column box">
                                    <b>Selected Y Axis ( {{ chartYAxis.length }} ) </b>
                                    <b-tooltip label="Delete All"  type="is-danger" ><b-button type="is-danger" icon-right="delete" v-show="chartYAxis.length>0"  @click="clearchartYAxis"  /></b-tooltip>
                                    <b-taglist>
                                        <b-tag type="is-primary" v-for="labelLab in labelParamsLabByKey" :key="labelLab">{{labelLab}}

                                        </b-tag>
                                    </b-taglist>
                                    <b-dropdown
                                            v-model="chartYAxis"
                                            multiple
                                    >
                                        <button class="button " type="button" slot="trigger">
                                            <span>Select Y Axis  ({{ chartYAxis.length }})</span>
                                            <b-icon icon="menu-down"></b-icon>
                                        </button>

                                        <b-dropdown-item  :value="dataLabParamsMasterNumberOnlyy.key" v-for="dataLabParamsMasterNumberOnlyy in dataLabParamsMaster_1NumberOnly" :key="dataLabParamsMasterNumberOnlyy.label">
                                            <span class="is-size-7"   >{{dataLabParamsMasterNumberOnlyy.label}}   </span>
                                            <span class="is-size-7"   > ( {{dataLabParamsMasterNumberOnlyy.group}} )  </span>
                                        </b-dropdown-item>

                                    </b-dropdown>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-collapse>
                <div class="content">
                    <div class="columns">
                        <div class="column">
                           <div class="container"  >
                             <LineChart_1   :datacollection="datacollectionToChart" 
                                            :options="options"  
                                            :triggerChange="triggerChange"  
                                            v-show="chartXAxis.length>0 && chartYAxis.length>0"  />
                           </div>
                        </div>
                        <div class="column" style=" overflow-x: scroll; overflow-y: scroll;">
                            <div class="container" v-show="chartXAxis.length>0 && chartYAxis.length>0 ">
                                <b-button type="is-danger" icon-left="delete"   :disabled="!chkRowsTblChart.length"   @click="delRowsTblChart"> Delete  </b-button>
                                  <section  >
                                    <b-table :data="arrTblDataChart"
                                             checkable
                                             :checked-rows.sync="chkRowsTblChart"
                                             checkbox-position="left"
                                             >

                                                <b-table-column v-for="(column, index) in arrColumnsChart"
                                                                :key="index"
                                                                :label="column.title"
                                                                :visible="column.visible"
                                                                v-slot="props"
                                                >
                                                    {{ props.row[column.field] }}
                                                </b-table-column>

                                    </b-table>
                                 </section>
                            </div>
                        </div>
                    </div>
                </div>
            </b-tab-item> -->


            <b-tab-item label="List of Orders" icon="test-tube" style=" overflow-x: scroll; overflow-y: scroll;" >
                <template slot="header">
                    <b-icon icon="table-large"></b-icon>
                    <span>List of Orders<b-tag  type="is-info" rounded v-if="listOHistoryOrders.length>0"> {{listOHistoryOrders.length }}  </b-tag> </span>
                </template>
                <nav class="level is-mobile">
                    <div class="level-left">
                        <div class="level-item">
                            <b-button type="is-success" outlined @click="reloadListOfHistoryOrder">Refresh</b-button>
                        </div>

                    </div>
                    <div class="level-right">

                    </div>
                </nav>

                <div class="box" v-if="listOHistoryOrders.length>0">
                    <b-table
                            :data="isEmpty ? [] : listOHistoryOrders"
                            :bordered="isBordered"
                            :striped="isStriped"
                            :narrowed="isNarrowed"
                            :hoverable="isHoverable"
                            :loading="isLoading"
                            :focusable="isFocusable"
                            :mobile-cards="hasMobileCards"
                            paginated
                            pagination-size="is-medium"
                            pagination-position="bottom"
                            :current-page.sync="currentPage"
                            :per-page="perPage" >


                        <b-table-column  label="Lab No."  centered v-slot="props">
<!--                            <b-button type="is-info"  >{{ props.row.idlaborder }}</b-button>-->
                          {{  props.row.idlaborder}}
                        </b-table-column>


                        <b-table-column field="kind" label="Walkin"   v-slot="props">
                              {{props.row.date_walkin}} - {{props.row.time_walkin}}
                        </b-table-column>

                        <b-table-column field="kind" label="WalkOut"   v-slot="props">
                            {{props.row.date_walkout}} - {{props.row.time_walkout}}
                        </b-table-column>

                        <b-table-column field="kind" label="Request"   v-slot="props">
                            {{props.row.grp_name}}
                        </b-table-column>

                        <b-table-column field="kind" label="User Rec."   v-slot="props">
                            {{props.row.user_rec_}}
                        </b-table-column>

                        <b-table-column field="kind" label="DVM."   v-slot="props">
                            {{props.row.dvm_}}
                        </b-table-column>

                        <b-table-column field="kind" label="Department"   v-slot="props">
                            {{props.row.dept}}
                        </b-table-column>

                        <b-table-column field="kind" label="DateTime Rec."   v-slot="props">
                            {{props.row.date_rec}} - {{props.row.time_rec}}
                        </b-table-column>



                        <b-table-column field="kind" label="LAB Related to"   v-slot="props" width="30"   >
<!--                            {{ props.row.idlab[0]}}-->
                            <div class="box" v-for="idlab in props.row.idlabs" :key="idlab.idlab">
                              <b-button type="is-info is-light"   icon-right="tag" @click="viewLab(idlab.idlab,idlab.kind_name)" >{{idlab.idlab}}</b-button>
                                <b-taglist attached>
                                    <b-tag type="is-dark">Status</b-tag>
                                    <b-tag :type="getTypeTags(idlab.status_id)">{{idlab.status_name}}</b-tag>
                                </b-taglist>
                            </div>
                        </b-table-column>







                        <template slot="empty">
                            <section class="section">
                                <div class="content has-text-grey has-text-centered">
                                    <p>
                                        <b-icon
                                                icon="emoticon-sad"
                                                size="is-large">
                                        </b-icon>
                                    </p>
                                    <p>Nothing here.</p>
                                </div>
                            </section>
                        </template>
                    </b-table>
                </div>


            </b-tab-item>



        </b-tabs>

        <SearchOPD  :mode="modeSearchOPD" @closeWithChange="closeSearchOPDWithChange"  ref="SearchOPD"/>
        <IMRHome   ref="IMRHome"/>
        <HistoryFinance   ref="HistoryFinance"/>

        <b-loading  :active.sync="isFullScreenLoading" ></b-loading>
<!--        @closeNotChange="closeSearchOPDWithNotChange"-->

        <!-- <b-modal
                v-if="isSortCBCTableShowing"
                v-model="isSortCBCTableShowing"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SortCBCTable v-if="isSortCBCTableShowing"
                     :cusNo="cusNoToChild" 
                     :isShowing="isSortCBCTableShowing"
                     @close="closeSortCBCTableShowing"
                    
            />
        </b-modal>   -->



         <b-modal
                v-if="isDlgSelectGrpLABForViewTableShowing"
                v-model="isDlgSelectGrpLABForViewTableShowing"
                has-modal-card
                :can-cancel="true">
            <DlgSelectGrpLABForViewTable v-if="isDlgSelectGrpLABForViewTableShowing"
                     :isShowing="isDlgSelectGrpLABForViewTableShowing"
                     @close="closeDlgSelectGrpLABForViewTable"
                     @closeWithRequest="closeDlgSelectGrpLABForViewTable_WithRequest"
                    
            />
        </b-modal>  




        <b-modal
                v-if="isSearchSomeTextInLabShowing"
                v-model="isSearchSomeTextInLabShowing"
                has-modal-card
                full-screen
                :can-cancel="true">
            <SearchSomeTextInLab 
                    @close="closeSearchSomeTextInLab"
                    
            />
        </b-modal> 





        <b-modal
                v-if="isSearchLabbyLabIDShowing"
                v-model="isSearchLabbyLabIDShowing"
                has-modal-card
                full-screen
        >

            <SearchLabbyLabID
                    v-if="isSearchLabbyLabIDShowing"
                    :isComponentModalActive ="isSearchLabbyLabIDShowing"
                    @close = "closeSearchLabbyLabID"
                   
            />
        </b-modal>







    </section>


</template>

<script>
    /* eslint-disable no-console */
    import { mapState , mapActions , mapGetters} from "vuex";
    import axios from "axios";
    import { getBaseURLforBackEnd  ,
             getConfigAxios ,
             getRgbaColor  ,
             getHardColor ,
             customFormatDate ,
             customFormatTime ,
             checkAccessTokenWithFpValid ,
             LOCATE_ENDPOINT_VIEWEACH_KINDLAB ,
             DATACYTOSPECLN_MODEL ,
             DATABIOPSPECLN_MODEL ,
             DATA_PCR_LN_MODEL,
             DATANECROPSPECLN_MODEL,
             DATA_BACT_LN_MODEL,
             DATA_PARA_LN_MODEL,
             DATA_ORGA_LN_MODEL,
            //  genUUID,
             }  from '@/utils.js'
    import sort from 'fast-sort'
    // import LineChart_1 from './Chart/LineChartComp'
    import SearchOPD from "./SearchOPD";
    import IMRHome from "./IMR/IMRHome";
    import HistoryFinance from "./HistoryFinance/HistoryFinance";

    import globalconst from '@/mixins/globalconst'
    import labStatusColor from "../mixins/methods/labStatusColor"
    import userRoleFind from "../mixins/methods/userRoleFind"
    import Cytology_EachID from "./LABNonAutomate/Cytology_EachID";
    import Biopsy_EachID from "./LABNonAutomate/Biopsy_EachID";
    import Necropsy_EachID from "./LABNonAutomate/Necropsy_EachID";
    import PCR_EachID from "./LABNonAutomate/PCR_EachID";
    import Bact_EachID from "./LABNonAutomate/Bact_EachID";
    import PARA_EachID from "./LABNonAutomate/PARA_EachID";
    import Orga_EachID from "./LABNonAutomate/Orga_EachID";

    // import CBC_DetailEachID from "./LABAutomate/CBC_DetailEachID";
    import CBC_DetailEachID_V2 from "./LABAutomate/CBC_DetailEachID_V2";



    import HeaderDecorate from "./LABNonAutomate/DecorateComponents/HeaderDecorate";
    import ListOfLabEachOPD from "./ListOfLabEachOPD";

    // import mobile  from 'is-mobile'

    import _ from 'lodash';

    // import ChartRawCBC from './ChartV2/ChartRawCBC'
    // import SortCBCTable from './SortCBCTable'



    import { genUUID } from '../utils';
    import DlgSelectGrpLABForViewTable from './DlgSelectGrpLABForViewTable.vue';

    // import FileSaver from 'file-saver'
    import getDecodeFromBase64ToHtml from '../mixins/methods/getDecodeFromBase64ToHtml' ;



    import TableAndChartCBC from '../components/ViewLabForOPDSpace/TableAndChartCBC.vue';
    
    
    
    import SearchSomeTextInLab from '../components/SearchSomeTextInLab/SearchSomeTextInLab.vue';
    import SearchLabbyLabID from './SearchLabbyLabID/SearchLabbyLabID';

    import CBC_Table_V3 from '@/components/LABAutomate/CBC_Table_V3.vue';
    import CBC_DetailEachID_V3 from './LABAutomate/CBC_DetailEachID_V3.vue';

    export default {
        name: "OPDSpace" ,
        mixins:[globalconst,labStatusColor,userRoleFind,getDecodeFromBase64ToHtml],
        components:{
            // LineChart_1,
            SearchOPD,
            IMRHome,
            HistoryFinance ,
            // CBC_DetailEachID,
            CBC_DetailEachID_V2,
            Cytology_EachID,
            Biopsy_EachID,
            Necropsy_EachID,
            PCR_EachID,
            Bact_EachID,
            PARA_EachID,
            Orga_EachID,
            HeaderDecorate,
            ListOfLabEachOPD,
            // ChartRawCBC,
            // SortCBCTable,
            DlgSelectGrpLABForViewTable,
            TableAndChartCBC,

            SearchSomeTextInLab ,

            SearchLabbyLabID,
            CBC_Table_V3 ,
          CBC_DetailEachID_V3,
        },
        computed:{
            ...mapState({
               OPDSelected : state => state.opd_target.opd_selected,
               // listOfLabOPDTarget: state => state.listoflab_opdtarget.listoflabopdtarget,
               listoflabopdtarget_v2 : state => state.listoflab_opdtarget.listoflabopdtarget_v2,
               IDLABSelected : state => state.lab_target.lab_selected,
               userCustomizeCBCTbl : state => state.master_data.userCustomizeCBCTbl,
               unitCBC : state => state.master_data.unitCBC,
               
               
               dataLabParamsMaster : state => state.master_data.dataLabParamsMaster,
               dataLabParamsMaster_1 : state => state.master_data.dataLabParamsMaster_1,
               dataLabParamsMaster_2 : state => state.master_data.dataLabParamsMaster_2,
            //    dataLabParamsMaster_3 : state => state.master_data.dataLabParamsMaster_3,

               dataLabParamsMasterUA  : state => state.master_data.dataLabParamsMasterUA,
               fingerPrint : state => state.master_data.fingerPrint,
               user_id : state => state.master_data.user_id,
               clientIP : state => state.master_data.clientIP,
               user_role :  state => state.master_data.user_role,
               userIsAdmin:  state => state.master_data.userIsAdmin,
               docKind : state => state.master_data.docKind,
               listOHistoryOrders  : state => state.listof_historyorders.listOHistoryOrders,
               countIMR : state => state.imr.countIMR,

               access_token: state => state.master_data.access_token,

            }) ,

            ...mapGetters('listoflab_opdtarget',{
                listOfLabOPDTarget_ModifiedForDisplay : 'listOfLabOPDTarget_ModifiedForDisplay'
            }),

            // getLabelHeaderPrepareInfo: function() {
            //     return ` Header Prepare Info.`
            // },
            // dataCBCSpecLNModifiAllDateTime: function () {
            //       return  {
            //                    "date_req" : this.dataCBCSpecLN.dat.date_req !== "" ?  customFormatDate(this.dataCBCSpecLN.dat.date_req): "" ,
            //                    "time_req" : this.dataCBCSpecLN.dat.time_req !== "" ?  customFormatTime(this.dataCBCSpecLN.dat.time_req)    : "",
            //                    "date_cancel" : this.dataCBCSpecLN.dat.date_cancel !== "" ?  customFormatDate(this.dataCBCSpecLN.dat.date_cancel)  : "" ,
            //                    "time_cancel" : this.dataCBCSpecLN.dat.time_cancel !== "" ? customFormatTime(this.dataCBCSpecLN.dat.time_cancel)  : "",
            //                    "date_reject" : this.dataCBCSpecLN.dat.date_reject !== "" ?  customFormatDate(this.dataCBCSpecLN.dat.date_reject)  : "" ,
            //                    "time_reject" : this.dataCBCSpecLN.dat.time_reject !== "" ? customFormatTime(this.dataCBCSpecLN.dat.time_reject)  : "",
            //                    "date_resulted" : this.dataCBCSpecLN.dat.date_resulted !== "" ?  customFormatDate(this.dataCBCSpecLN.dat.date_resulted)  : "" ,
            //                    "time_resulted" : this.dataCBCSpecLN.dat.time_resulted !== "" ? customFormatTime(this.dataCBCSpecLN.dat.time_resulted)  : "",
            //               }
            // },
            calTblHigth(){
               return this.dataRawCBC_Filter_Spec_is_visible.length>10 ?  "700" : "auto"
            },
            dataLabParamsMaster_Count_isSwitchedCUS1(){
                return this.dataLabParamsMaster.filter(dat=>dat.isSwitchedCUS1)
                                               .length 
            },
            dataLabParamsMasterFilter : function(){
               return this.dataLabParamsMaster.filter(dat=>{
                if (
                        (dat.label.toUpperCase().indexOf(this.searchTxtParam.toUpperCase()) > -1  )
                   ||   (dat.label_1.toUpperCase().indexOf(this.searchTxtParam.toUpperCase()) > -1  )
                   
                   ){
                      
                        return  dat
                    }
            })
            },



            queries(){
                return this.searchTxtParam.split(" ");
            },
            dataRawCBC_Filter_Spec_is_visible(){
                 return this.dataRawCBC.filter(dat=>dat.is_visible)
            },
            // calHigthTbl(){
            //   return  this.dataRawCBC_Filter_Spec_is_visible.length<=5 ? 500 : this.dataRawCBC_Filter_Spec_is_visible.length*100
           
            // },
            computeColumn(){
                const tmp0 =_.sortBy(this.dataLabParamsMaster, 'order'); 
                // console.log(tmp0)
                const tmp = tmp0.filter(dat=>dat.isSwitchedCUS1)
                 
                let tmp1 = tmp.map(dat=>{
                                                 return { field : dat.key, label : dat.label,width : 50 , centered : true ,headerClass: "is-sticky-column-one" , uuid : genUUID(4) } 
                                               }) 
                
                 
                tmp1.unshift({ field: 'time_req', label: 'Time' ,width : 60    , uuid:  genUUID(4)  } )
                tmp1.unshift({ field: 'date_req', label: 'Date' ,width : 120    , uuid:  genUUID(4) } )
                tmp1.unshift({ field: 'idlab', label: 'LAB ID' ,width : 40 , sticky: true,  headerClass: "is-sticky-column-one",  cellClass: "is-sticky-column-two" , uuid:  genUUID(4)} )
            


                return tmp1                               
            },
            dataRawCBC_Chunk(){
                 return _.chunk(Object.values(this.dataRawCBC), 4);    
            },
            listOfLabOPDTarget_ModifiedForDisplayByFilter: function(){
               return  this.listOfLabOPDTarget_ModifiedForDisplay.filter(dat=>{
                   return dat.kind.indexOf(this.docKindSelected)>-1 //
               })
            },
            dataLabParamsMaster_1NumberOnly: function () {
              return this.dataLabParamsMaster.filter( dat => dat.isNumberic )
            } ,
            labelParamsLabByKey: function(){
                var tmpLabelLab = []
                for (var i = 0 ; i < this.chartYAxis.length ; i++){
                    const member = this.dataLabParamsMaster.find(member => member.key ===  this.chartYAxis[i])
                    if(member) {
                        tmpLabelLab.push(member.label)
                    }
                }
              return tmpLabelLab
            },
            displayDateTimeByIdlabInObj: function(){
                var tmpDateTimeByIdlab = []
                for (var idlab =0 ; idlab< this.chartXAxis.length; idlab++ ){
                    for(var idxRawData =0 ; idxRawData< this.dataRawCBC.length;idxRawData++){
                        if(this.dataRawCBC[idxRawData].idlab === this.chartXAxis[idlab]) {
                            tmpDateTimeByIdlab.push(
                                {
                                    'date_req' : this.dataRawCBC[idxRawData].date_req,
                                    'time_req' : this.dataRawCBC[idxRawData].time_req,
                                    'idlab' :  this.dataRawCBC[idxRawData].idlab
                                }
                                )
                        }
                    }
                }

                return tmpDateTimeByIdlab

            },
            displayDateTimeByIdlabMixStrInArr: function(){
                var tmpDateTimeByIdlab = []
                for (var idlab =0 ; idlab< this.chartXAxis.length; idlab++ ){
                    for(var idxRawData =0 ; idxRawData< this.dataRawCBC.length;idxRawData++){
                        if(this.dataRawCBC[idxRawData].idlab === this.chartXAxis[idlab]) {

                            tmpDateTimeByIdlab.unshift(
                                this.dataRawCBC[idxRawData].idlab+
                                '  ('+
                                this.dataRawCBC[idxRawData].date_req +
                                '  '+
                                this.dataRawCBC[idxRawData].time_req  +
                                ') '
                            )


                            // tmpDateTimeByIdlab.push(
                            //     this.dataRawCBC[idxRawData].idlab+
                            //       '  ('+
                            //      this.dataRawCBC[idxRawData].date_req +
                            //        '  '+
                            //     this.dataRawCBC[idxRawData].time_req  +
                            //      ') '
                            // )
                        }
                    }
                }
                // console.log('tmpDateTimeByIdlab')
                // console.log(tmpDateTimeByIdlab)
                return tmpDateTimeByIdlab


            },
            chartXAndChartYChange(){
                const {chartXAxis, chartYAxis} = this
                return {chartXAxis, chartYAxis}
            } ,
            formatDatRawCBC: function () {  // such as format date
             return   this.dataRawCBC.map(dat => {
                 return {
                        "date_req" :  dat.date_req = customFormatDate(dat.date_req) ,
                        "time_req" :  dat.time_req = customFormatTime(dat.time_req) ,
                        "idlab" : dat.idlab
                 }
                })
            },
            dataRawCBCWithHightlightHold: function () {
               // return ...(dataRawCBC.hold.


               //  return   this.dataRawCBC.map(dat =>
               //          dat.hm_hgb = '12'
               // )


              return  _.map( this.dataRawCBC , (item) => {
                    if (item.hold) {
                        // item.hm_hgb =  `<p class="has-text-primary">${item.hm_hgb}</p>`
                        this.dataLabParamsMaster.forEach(dat=>{
                            item[dat.key] = `<p class="has-text-info-dark">${ item[dat.key] }</p>`
                        })
                    }
                    return item;
                });
            },
            // dataRawCBC_Filter_From_checkboxGroupIDLAB(){
            //     return this.dataRawCBC.filter(dat=> this.checkboxGroupIDLAB.includes(dat.idlab) )
            // },
             
        },
        methods:{
            ...mapActions({
                setupIDLABTarget : 'lab_target/setupIDLABTarget',
                setupIDOPDTarget : 'opd_target/setupIDOPDTarget',
                // fetchListOfLab_OPDTarget :'listoflab_opdtarget/fetchListOfLab_OPDTarget',
                fetchListOfLab_OPDTargetV2: 'listoflab_opdtarget/fetchListOfLab_OPDTargetV2',
                fetchListOHistoryOrders : 'listof_historyorders/fetchListOHistoryOrders',
                clearListOHistoryOrders : 'listof_historyorders/clearListOHistoryOrders',
                fetchCountIMR : 'imr/fetchCountIMR',
                fetchMyJobsTray: 'myjobstray/fetchMyJobsTray',
            }),

           showSearchLabbyLabID(){
              this.isSearchLabbyLabIDShowing = true
           },
           closeSearchLabbyLabID(){
              this.isSearchLabbyLabIDShowing = false
           },




           closeSearchSomeTextInLab(){
                this.isSearchSomeTextInLabShowing = false
           }, 
           showSearchSomeTextInLab(){
                this.isSearchSomeTextInLabShowing = true
           },

           inputTabOPDSpace(){
            // console.log(this.tabOPDSpace)
            if(this.tabOPDSpace==0){
            //    console.log(this.tabOPDSpace) 
               this.$refs.ListOfLabEachOPD.chengeToDefaultField(false)
            }
           }, 
           saveParamSort(cusNo){
               let datTo = {
                "cus_no" : "cus1",
                "data" : null
               }
               if (cusNo == 0){
               datTo.data =   this.dataLabParamsMaster 
               }else  if (cusNo == 1){
               datTo.data =  this.dataLabParamsMaster_1  
               }else  if (cusNo == 2){
               datTo.data =  this.dataLabParamsMaster_2  
               }

               this.isFullScreenLoading = true 
                //  console.log(JSON.stringify(datTo))
               axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
               axios.post(`${getBaseURLforBackEnd()}/api/upcuscbc`, datTo, getConfigAxios())
                    .then((res)=>{
                         this.$buefy.toast.open({
                                    duration: 2000,
                                    message: `${res.data.msg}`,
                                    type: 'is-success'
                         })
                         this.isFullScreenLoading = false
                    })

                    .catch((err)=>{
                        this.$buefy.dialog.alert({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            hasIcon: true,
                            icon: 'alert-circle',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        this.isFullScreenLoading = false
                    })
                   


           }, 
           closeDlgSelectGrpLABForViewTable_WithRequest(payload){
               this.isDlgSelectGrpLABForViewTableShowing = false
               this.viewCBCAsPDFTablesData_1(payload)
           },
           closeDlgSelectGrpLABForViewTable(){
               this.isDlgSelectGrpLABForViewTableShowing = false
           },
           openDlgViewCBCAsPDFTablesData_1(){
               this.isDlgSelectGrpLABForViewTableShowing = true
           },
           async viewCBCAsPDFTablesData_1(payload){
                      this.isBtnViewCBCAsPDFTablesData = true
                        const datTo = {
                            "idopd" :  this.OPDSelected.idopd,
                            "hematology"  : payload.hematology,
                            "blood_chem"  : payload.blood_chem,
                            "body_fluid"  : payload.body_fluid,
                            "blood_gas"   : payload.blood_gas,
                            "hormone"     : payload.hormone,
                            "outlab"      : payload.outlab                           
                        }
                        await  axios.post(`${getBaseURLforBackEnd()}/api/make_pdf_cbc_table_data_v2` ,datTo, getConfigAxios())
                               .then((res)=>{
                                     this.isBtnViewCBCAsPDFTablesData = false
                                    // FileSaver.saveAs(`${res.data.url}`,`${res.data.file_name}`);
                                     window.open(`${res.data.url}`, '_blank')
                                    //window.open(`${res.data.url}`, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes')  
                               })    
           },
           async viewCBCAsPDFTablesData(){
                        this.isBtnViewCBCAsPDFTablesData = true
                        const datTo = {
                            "idopd" :  this.OPDSelected.idopd
                        }
                        await  axios.post(`${getBaseURLforBackEnd()}/api/make_pdf_cbc_table_data` ,datTo, getConfigAxios())
                               .then((res)=>{
                                     this.isBtnViewCBCAsPDFTablesData = false
                                    // FileSaver.saveAs(`${res.data.url}`,`${res.data.file_name}`);
                                     window.open(`${res.data.url}`, '_blank')
                                    //window.open(`${res.data.url}`, '_blank', 'location=no,height=570,width=520,scrollbars=yes,status=yes')  
                               })

           },





           closeSortCBCTableShowing(){
                this.isSortCBCTableShowing = false
           },
           showDlgParamSortMode(cusNo){
                this.cusNoToChild = cusNo
                this.isSortCBCTableShowing = true
           },

           
           
           
           

           // ******************************
           // Select Unselect All Lab ID
           // ******************************
           unSelectAllLabInThisPage(){
            const arr = _.chunk( this.dataRawCBC.map(dat=>dat.idlab),this.tbldataRawCBCPerPage)
            const arrWant = arr[this.currentPage_tbldataRawCBCPerPage-1]
            //
            this.dataRawCBC.forEach(dat=>{
                if (arrWant.indexOf( dat.idlab )>-1){
                    dat.is_visible = false
                }
            }) 
            

           }, 


           selectAllLabInThisPage(){
            const arr = _.chunk( this.dataRawCBC.map(dat=>dat.idlab),this.tbldataRawCBCPerPage)
            const arrWant = arr[this.currentPage_tbldataRawCBCPerPage-1]
            //
            this.dataRawCBC.forEach(dat=>{
                if (arrWant.indexOf( dat.idlab )>-1){
                    dat.is_visible = true
                }
            }) 
            

           },

           // ******************************
           // Select Unselect All Param 
           // ******************************
           unSelectAllParamsInThisPage(){
            const tmpArr = this.dataLabParamsMaster.map(dat=>dat.key)
            const tmpArr1 =  _.sortBy(tmpArr,"order") 
            const arr = _.chunk(  tmpArr1 ,this.tblDataLabParamsMasterperPage)
            const arrWant = arr[this.currentPage_tblDataLabParamsMasterperPage-1]
            //
            this.dataLabParamsMaster.forEach(dat=>{
                if (arrWant.indexOf( dat.key )>-1){
                    dat.isSwitchedCUS1 = false
                }
            }) 
            

           }, 


           selectAllParamsInThisPage(){
            const tmpArr = this.dataLabParamsMaster.map(dat=>dat.key)
            const tmpArr1 =  _.sortBy(tmpArr,"order") 
            const arr = _.chunk(  tmpArr1 ,this.tblDataLabParamsMasterperPage)
            const arrWant = arr[this.currentPage_tblDataLabParamsMasterperPage-1]
            //
            this.dataLabParamsMaster.forEach(dat=>{
                if (arrWant.indexOf( dat.key )>-1){
                    dat.isSwitchedCUS1 = true
                }
            }) 
            

           },










            
           getDateTimeFromIDLAB(_idlab){
                const tmp = this.dataRawCBC.find(dat=>dat.idlab==_idlab)
                return tmp ? 
                           {
                            "date_req" : tmp.date_req,
                            "time_req" : tmp.time_req,
                           }
                           :
                           {
                            "date_req" : "",
                            "time_req" : "",
                           }
           },
           clickCopyIntoClipboard(_id){
              this.$buefy.toast.open({
                    duration: 2000,
                    message: `Copy <b>${_id}</b> to clipboard`,
                    position: 'is-bottom',
                    type: 'is-primary is-light'
                })
           }, 
           viewLabEmitBy_ListOfLabEachOPD(payload){
              this.viewLab(payload.id,payload.kindoflab)
            },
           getTypeTags(id){
                  // console.log(id)
                var tmpReturn = ''
                 switch(id) {
                   case 7:
                         tmpReturn = 'is-danger'
                         break;
                   case 6:
                       tmpReturn = 'is-success'
                       break;
                   case 5:
                       tmpReturn = 'is-success'
                       break;
                   default:
                       tmpReturn = 'is-info'
               }

                  return tmpReturn
            },
          reloadListOfHistoryOrder(){
                // console.log(this.OPDSelected.idopd)
                this.isFullScreenLoading = true
                const vm = this
                this.fetchListOHistoryOrders(this.OPDSelected.idopd)
                 .then(()=>{
                         setTimeout(()=>{
                             vm.isFullScreenLoading = false
                         },1000)

                 })
                 .finally(()=>{
                         setTimeout(()=>{
                             vm.isFullScreenLoading = false
                         },500)
                 })

          },
          closeEditDocLAB(){
              this.$refs.btnRefreshLN.$el.click()
              //
              for(var i = 2;i<=5;i++) {
                  const payloadDatTo = {
                      "user_id": this.user_id,
                      // "status_id": this.status
                      "status_id": i
                  }

                  this.fetchMyJobsTray(payloadDatTo)
                      .then(() => {
                          setTimeout(() => {
                              this.isFullScreenLoading = false
                          }, 500)
                      })
                      .catch((err) => {

                          // console.log('do here 5555')

                          this.isFullScreenLoading = false

                          // vm.isFullScreenLoading = false
                          this.$buefy.dialog.alert({
                              title: 'Error',
                              message: `${err}`,
                              type: 'is-danger',
                              hasIcon: true,
                              icon: 'times-circle',
                              iconPack: 'fa',
                              ariaRole: 'alertdialog',
                              ariaModal: true
                          })
                      })
              }
          },
          openHistoryFinance(){
              this.$refs.HistoryFinance.isComponentModalActive = true
              this.$refs.HistoryFinance.loadVisitWalkin()
              this.$refs.HistoryFinance.datHistoryFinance = []
          },
          openIMRHome(){
            this.$refs.IMRHome.isComponentModalActive = true
            this.$refs.IMRHome.loadDateImrAvaliable()
            this.$refs.IMRHome.loadDocTypeImrAvaliable()
            this.$refs.IMRHome.dataIMRs = []
          }
            ,
          // async  getCountIMR(idopd){
          //     const datPost = {
          //         "idopd" : idopd
          //     }
          //     const vm = this
          //     await  axios.post(`${getBaseURLforBackEnd()}/api/imr_countbyopdno` ,datPost, getConfigAxios())
          //         .then((res) => {
          //             vm.imrCount = res.data.count
          //         })
          //
          // },
          async  closeSearchOPDWithChange(changeToOPDNo){
               this.isFullScreenLoading = true
                  if(!this.user_id){
                      this.$router.push('/login')
                          .catch(()=>{});
                      this.isFullScreenLoading = false    
                      return
                  }


                var opd_selected={
                    acceptby:"",
                    age :"",
                    automate: "",
                    cancleby :"",
                    date:"",
                    dateaccept: "",
                    datecancle:"",
                    datereject:"",
                    datereq:"",
                    dateresult:"",
                    gender:"",
                    idlab:"",
                    idopd:"" ,
                    kind: "",
                    opdname: "",
                    owner_name: "" ,
                    rejectby: "",
                    reqby: "",
                    resultby: "",
                    status: "",
                    timeaccept: "",
                    timecancle : "",
                    timereject : "" ,
                    timereq : "",
                    timeresult: "",
                    type : ""
                }
                // fetch info OPD
                const datPost = {
                    "idopd" : changeToOPDNo ,
                    "user" :  this.user_id ,
                    "ip" : this.clientIP
                }
                const vm = this
              // log
              await  axios.post(`${getBaseURLforBackEnd()}/api/opdinfo_by_hn` ,datPost, getConfigAxios())
                    .then((res) => {

                        opd_selected.idopd = res.data.idopd
                        opd_selected.opdname = res.data.name
                        opd_selected.owner_name = res.data.owner_name
                        opd_selected.gender = res.data.sex
                        opd_selected.age = res.data.age
                        opd_selected.type =res.data.species +'(' + res.data.breed +' )'

                        vm.setupIDOPDTarget(opd_selected)

                        // vm.fetchListOfLab_OPDTarget(opd_selected.idopd)
                    })
                  .catch( function(err) {
                      this.isFullScreenLoading = false
                      console.log('error : '+err)
                      if (err.response && err.response.status === 401) {
                          vm.$router.push('/login')
                          .catch(()=>{});
                      }
                      else if (err.response && err.response.status === 500) {
                          vm.$router.push('/login')
                          .catch(()=>{});
                      }
                      else if (err.response && err.response.status === 422) {
                          vm.$router.push('/login')
                          .catch(()=>{});
                      }
                  })



                // change opd no to state
                // fetch List of Lab for new OPD No.
              await this.fetchListOfLab_OPDTargetV2(this.OPDSelected.idopd)
                        .then(()=>{
                            this.isFullScreenLoading = false
                            this.$buefy.snackbar.open({
                                        duration: 1500,
                                        message: `laboratory list loaded successfully. `,
                                        type: 'is-success',
                                        position: 'is-bottom-left',
                                        actionText: 'OK',
                                        queue: false,
                                    })
                            this.$refs.ListOfLabEachOPD.chengeToDefaultField(false)        
                        }) 
                        .catch(()=>{
                            this.isFullScreenLoading = false
                        })

              this.$refs.ListOfLabEachOPD.searchTxt = ""
              // await this.fetchListOfLab_OPDTarget(this.OPDSelected.idopd)
                    // .then((res)=>{
                    //       // console.log(res.data)
                    //       // console.log(res.data.length)
                    //       // vm.totalLabCount =  res.data.length
                    // })

              // this.getCountIMR(this.OPDSelected.idopd)
              this.fetchCountIMR(this.OPDSelected.idopd)



                // change spec target lab is null
                this.setupIDLABTarget( {
                    "idlab" : null,
                    "kind" : null
                })



                // clear CBC table
                this.dataRawCBC=[]
                this.chartXAxis=[]
                this.chartYAxis=[]
                this.columnsCUS1.splice(3)
                // clear order history
               this.clearListOHistoryOrders()

                // display opd info
                this.tabOPDSpace = 0


                //
                this.isSwitchedCusColumn = false
                this.isSwitchedChartRawCBC = false


                // make sure
                this.isFullScreenLoading = false
            },

          searchNewOPD(){
               this.$refs.SearchOPD.isComponentModalActive = true
          },
          delRowsTblChart(){

                for (var idxChkRowsTblChart=0 ;idxChkRowsTblChart < this.chkRowsTblChart.length ;idxChkRowsTblChart++ ){
                    for(var idxDataChartXAxis = 0;idxDataChartXAxis< this.chartXAxis.length;idxDataChartXAxis++){
                        if(this.chartXAxis[idxDataChartXAxis] === this.chkRowsTblChart[idxChkRowsTblChart].idlab){
                            this.chartXAxis.splice( idxDataChartXAxis ,1)
                         }
                    }
                }

                this.chkRowsTblChart= []
            },
            clearchartXAxis(){
                this.chartXAxis = []
            },
            clearchartYAxis(){
                this.chartYAxis = []
            },

            loadUnitCBC(){
                const vm = this
                axios.get(`${getBaseURLforBackEnd()}/api/labcbc_units`, getConfigAxios())
                    .then((res) => {
                        vm.unitCBC =  res.data
                    })
            },
        trigForPlusUpdate(){
                // console.log('trigForPlusUpdate')
                this.viewSpecLab()
        },
        viewSpecLab(){
                // console.log('this.IDLABSelected')
                // console.log(this.IDLABSelected)
                if(!this.user_id){
                    this.$router.push('/login')
                        .catch(()=>{});
                    return
                }


                this.isFullScreenLoading = true
                // init
                this.dataCBCSpecLN = null
                this.dataCytoSpecLN = DATACYTOSPECLN_MODEL
                // this.dataBiopsySpecLN  =  { "dat_prepare": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "dat_ct": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "img": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "diag_code": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "status": { "id": "", "name": "" }, "assigned_to_user": { "id": "", "name": "" } , "data_req": [] }
                this.dataBiopsySpecLN  =  DATABIOPSPECLN_MODEL
                this.dataPCRSpecLN = DATA_PCR_LN_MODEL
                this.dataBACTSpecLN = DATA_BACT_LN_MODEL
                this.dataPARASpecLN = DATA_PARA_LN_MODEL
                this.dataORGASpecLN = DATA_ORGA_LN_MODEL
                this.dataNecropsySpecLN = DATANECROPSPECLN_MODEL



                // init
                this.isCytoShowing = false

                const dat = {
                    "ln": this.IDLABSelected.idlab,
                    "user": this.user_id ,
                    "ip": this.clientIP
                }
                // console.log(JSON.stringify(dat))
                const vm  = this
                // console.log(LOCATE_ENDPOINT_EACH_KINDLAB.CBC)
                if((this.IDLABSelected.kind).toUpperCase() === "CBC") {
                    // attach access_token it
                  
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.CBC}`, dat, getConfigAxios())
                        .then((res) => {
                            vm.dataCBCSpecLN = res.data
                            // console.log(JSON.stringify(vm.dataCBCSpecLN))
                            
                            vm.dataCBCSpecLN['info'].comment_note =  vm.dataCBCSpecLN['info'].comment_note ? vm.getDecodeFromBase64ToHtml( vm.dataCBCSpecLN['info'].comment_note )    :  vm.dataCBCSpecLN['info'].comment_note  
                            vm.dataCBCSpecLN['info'].tentative_dx =  vm.dataCBCSpecLN['info'].tentative_dx ? vm.getDecodeFromBase64ToHtml( vm.dataCBCSpecLN['info'].tentative_dx )    :  vm.dataCBCSpecLN['info'].tentative_dx  
                            vm.dataCBCSpecLN['info'].diagnosis_note =  vm.dataCBCSpecLN['info'].diagnosis_note ? vm.getDecodeFromBase64ToHtml( vm.dataCBCSpecLN['info'].diagnosis_note )    :  vm.dataCBCSpecLN['info'].diagnosis_note  
                            vm.dataCBCSpecLN['info'].result_remark =  vm.dataCBCSpecLN['info'].result_remark ? vm.getDecodeFromBase64ToHtml( vm.dataCBCSpecLN['info'].result_remark )    :  vm.dataCBCSpecLN['info'].result_remark  



                            vm.isFullScreenLoading = false
                        })
                        .catch(function (err) {
                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                                vm.isFullScreenLoading = false
                                return
                            }
                            if (err.response && err.response.status === 422) {
                                vm.isFullScreenLoading = false
                                vm.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `Token expired , please login again`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true,
                                    onConfirm: () =>   vm.$router.go()
                                })
                                return
                            }
                            vm.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `${err}   ${err.response.data}`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true
                            })
                            vm.isFullScreenLoading = false

                        })
                }




                if((this.IDLABSelected.kind).toUpperCase() === "CYTOLOGY") {
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.CYTOLOGY}`, dat, getConfigAxios())
                        .then((res) => {
                            vm.dataCytoSpecLN =  res.data
                            // console.log(JSON.stringify(vm.dataCytoSpecLN))
                            vm.isFullScreenLoading = false
                            vm.isCytoShowing = true
                            // console.log(this.IDLABSelected.idlab)
                            // console.log('viewSpecLab')
                            // console.log(JSON.stringify( vm.dataCytoSpecLN))
                        })
                        .catch( function(err) {
                            vm.isFullScreenLoading = false
                            vm.$buefy.dialog.confirm({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }

                            if (err.response && err.response.status === 422) {
                                vm.isFullScreenLoading = false
                                vm.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `Token expired , please login again`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true,
                                    onConfirm: () =>   vm.$router.go()
                                })
                            }


                        })


                  

                }




                if((this.IDLABSelected.kind).toUpperCase() === "BIOPSY") {
                    // attach access_token it
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.BIOPSY}`, dat, getConfigAxios())
                        .then((res) => {
                            // console.log('doooo 555')
                            // console.log(JSON.stringify(res.data))
                            vm.dataBiopsySpecLN = res.data
                            vm.isFullScreenLoading = false
                        })
                        .catch(function (err) {
                            vm.isFullScreenLoading = false
                            vm.$buefy.dialog.confirm({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                            if (err.response && err.response.status === 422) {
                                vm.isFullScreenLoading = false
                                vm.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `Token expired , please login again`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true,
                                    onConfirm: () =>   vm.$router.go()
                                })
                            }


                        })
                }



                if((this.IDLABSelected.kind).toUpperCase() === "NECROPSY") {
                    // attach access_token it
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.NECROPSY}`, dat, getConfigAxios())
                        .then((res) => {
                            // console.log('doooo 555')
                            // console.log(JSON.stringify(res.data))
                            vm.dataNecropsySpecLN = res.data
                            vm.isFullScreenLoading = false
                        })
                        .catch(function (err) {
                            vm.isFullScreenLoading = false
                            vm.$buefy.dialog.confirm({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                            if (err.response && err.response.status === 422) {
                                vm.isFullScreenLoading = false
                                vm.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `Token expired , please login again`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true,
                                    onConfirm: () =>   vm.$router.go()
                                })
                            }


                        })
                }






                if((this.IDLABSelected.kind).toUpperCase() === "PCR") {
                    // attach access_token it
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}` 
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.PCR}`, dat, getConfigAxios())
                        .then((res) => {
                            // console.log( res.data )
                            vm.dataPCRSpecLN = res.data
                            vm.isFullScreenLoading = false
                        })
                        .catch(function (err) {
                            vm.isFullScreenLoading = false
                            vm.$buefy.dialog.confirm({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                            if (err.response && err.response.status === 422) {
                                vm.isFullScreenLoading = false
                                vm.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `Token expired , please login again`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true,
                                    onConfirm: () =>   vm.$router.go()
                                })
                            }


                        })
                }





                if((this.IDLABSelected.kind).toUpperCase() === "ORGANISM") {
                    // attach access_token it
                    axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                    axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.ORGANISM}`, dat, getConfigAxios())
                        .then((res) => {
                            vm.dataORGASpecLN  = res.data
                            vm.isFullScreenLoading = false
                        })
                        .catch(function (err) {
                            vm.isFullScreenLoading = false
                            vm.$buefy.dialog.confirm({
                                title: 'Error',
                                message: `${err}`,
                                type: 'is-danger',
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true
                            })
                            if (err.response && err.response.status === 401) {
                                vm.$router.push('/login')
                            }
                            if (err.response && err.response.status === 422) {
                                vm.isFullScreenLoading = false
                                vm.$buefy.dialog.alert({
                                    title: 'Error',
                                    message: `Token expired , please login again`,
                                    type: 'is-danger',
                                    hasIcon: true,
                                    icon: 'times-circle',
                                    iconPack: 'fa',
                                    ariaRole: 'alertdialog',
                                    ariaModal: true,
                                    onConfirm: () =>   vm.$router.go()
                                })
                            }


                        })
                }





               if((this.IDLABSelected.kind).toUpperCase() === "BACTERIAL") {
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.BACTERIAL}`, dat, getConfigAxios())
                    .then((res) => {
                        // console.log( res.data )
                        //  console.log(JSON.stringify('dataBACTSpecLN res data --->', res.data))
                        vm.dataBACTSpecLN = res.data
                        vm.isFullScreenLoading = false
                    })
                    .catch(function (err) {
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.confirm({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')

                        }
                        if (err.response && err.response.status === 422) {
                            vm.isFullScreenLoading = false
                            vm.$buefy.dialog.alert({
                                title: 'Error',
                                message: `Token expired , please login again`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true,
                                onConfirm: () =>   vm.$router.go()
                            })
                        }

                    })
                }





               if((this.IDLABSelected.kind).toUpperCase() === "PARASITE") {
                // attach access_token it
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}${LOCATE_ENDPOINT_VIEWEACH_KINDLAB.PARASITE}`, dat, getConfigAxios())
                    .then((res) => {
                        vm.dataPARASpecLN = res.data
                        vm.isFullScreenLoading = false
                    })
                    .catch(function (err) {
                        vm.isFullScreenLoading = false
                        vm.$buefy.dialog.confirm({
                            title: 'Error',
                            message: `${err}`,
                            type: 'is-danger',
                            icon: 'times-circle',
                            iconPack: 'fa',
                            ariaRole: 'alertdialog',
                            ariaModal: true
                        })
                        if (err.response && err.response.status === 401) {
                            vm.$router.push('/login')

                        }
                        if (err.response && err.response.status === 422) {
                            vm.isFullScreenLoading = false
                            vm.$buefy.dialog.alert({
                                title: 'Error',
                                message: `Token expired , please login again`,
                                type: 'is-danger',
                                hasIcon: true,
                                icon: 'times-circle',
                                iconPack: 'fa',
                                ariaRole: 'alertdialog',
                                ariaModal: true,
                                onConfirm: () =>   vm.$router.go()
                            })
                        }

                    })
                 }




                  


            },
           async viewLab(idlab,kindoflab){
                // console.log(idlab+'   '+kindoflab)
                // change state
                const dat ={
                    "idlab" : idlab,
                    "kind" : kindoflab
                }
               await this.setupIDLABTarget(dat)
                      // .then(()=>{
                      //     // console.log(JSON.stringify(this.dataBiopsySpecLN))
                      //     // console.log(JSON.stringify(this.dataCytoSpecLN))
                      // })
                // change tab index
                this.tabOPDSpace = 1
                // and display(maybe)
                this.$refs.btnRefreshLN.$el.click()
                this.$buefy.toast.open({
                    duration: 800,
                    message: `Change Lab No to ${dat.idlab}`,
                    position: 'is-bottom',
                    type: 'is-info'
                })
            },

            fetchDataRawCBC(){
                if(!this.user_id){
                    this.$router.push('/login')
                        .catch(()=>{});
                    return
                }

                const dat =     {
                    "opdno": this.OPDSelected.idopd ,
                    "user": this.user_id,
                    "ip": this.clientIP
                }
                // this.isBtnRefreshCBC = true
                this.isFullScreenLoading = true
                this.isSwitchedCusColumn = false
                this.isSwitchedChartRawCBC = false

               // this.isBtnRefreshCBC = false   
                const vm = this
                checkAccessTokenWithFpValid(this.fingerPrint)
                    .then((res)=>{
                        if(!res.data.access_token_valid){
                            this.$router.push('/login')
                                .catch(()=>{});
                        }
                    })
                    .catch(()=>{
                        this.$router.push('/login')
                            .catch(()=>{});
                    })

                 
                // attach access_token it
                axios.defaults.headers.common['Authorization'] = `Bearer ${this.access_token}`
                axios.post(`${getBaseURLforBackEnd()}/api/labcbclist_spec_opdno_v2`,dat,getConfigAxios())
                    .then( (res)=> {
                        vm.dataRawCBC = [] // reset old data
                        vm.dataRawCBC = res.data
                        
                        // console.log(JSON.stringify(res.data))
                        //
                        this.currentPage_tblRawCBCperPage = 1
                        this.currentPage_tbldataRawCBCPerPage = 1
                        this.paginatedLABIDTblMode = true
                        this.searchTxtParam = ""
                        //
                        // this.isSwitchedCusColumn = false
                        // reset chart
                        vm.chartXAxis = []
                        vm.chartYAxis = []

                       // vm.makeAllColumn( vm.columnsCUS1 )
                        //
                        //vm.makeColumn_V2(vm.userCustomizeCBCTbl.cus1,vm.columnsCUS1)
                         
                        //vm.makeColumn(vm.userCustomizeCBCTbl.cus1,vm.columnsCUS1)
                        // vm.makeColumn(vm.userCustomizeCBCTbl.cus2,vm.columnsCUS2)
                        // vm.makeColumn(vm.userCustomizeCBCTbl.cus3,vm.columnsCUS3)

                        // checkboxGroupIDLAB for first 5 idlab

                        for(var i=0;i<=4;i++){
                               vm.dataRawCBC[i].is_visible= true
                        } 
                         
                         
                         
                        // vm.checkboxGroupIDLAB =  vm.dataRawCBC.slice(0,5)
                        //                            .map(dat=>dat.idlab)





                        // console.log("1-->",vm.checkboxGroupIDLAB )
                        // vm.checkboxGroupIDLAB = vm.checkboxGroupIDLAB.map(dat=>dat.idlab)
                        // console.log("2-->",vm.checkboxGroupIDLAB )

                        //
                        //    vm.isBtnRefreshCBC = true


                        //
                        // vm.dataLabParamsMaster.forEach(function (element) {
                        //             element.uuid = genUUID(8) 
                        //             });
                        // console.log(genUUID(8))                                    
                        // vm.dataLabParamsMaster.map(obj => ({ ...obj, "uuid": "test" }))



                        vm.isFullScreenLoading = false
                     
                      

                    })
                    .catch(function (err) {
                        this.$buefy.toast.open({
                            duration: 1400,
                            message: `Sometime wrong with ${err} pls try again `,
                            position: 'is-bottom',
                            type: 'is-danget'
                        })
                        // vm.isBtnRefreshCBC = false
                        vm.isFullScreenLoading = false
                    })
                    .finally(()=>{
                        // vm.isBtnRefreshCBC = false
                        vm.isFullScreenLoading = false
                    })

                // force to change tab
                // this.tabOPDSpace = 2
            },

            
             
            removeRowOfIDLAB(_idlab){
            // console.log(_idlab)
            const tmp = this.dataRawCBC.find(dat=>dat.idlab == _idlab)
            if(tmp){
                tmp.is_visible = false
            }
            //    const tmpIndex = this.checkboxGroupIDLAB.indexOf(_idlab)
            //    if ( tmpIndex >-1) {
            //      this.checkboxGroupIDLAB.splice(tmpIndex,1)
            //    }

            },
            isColumnField(column_field){
            //    console.log(column_field)
            //  const tmp = this.dataLabParamsMaster.find(dat=>dat.field == column_field)
              return this.dataLabParamsMaster.find(dat=>dat.key == column_field)
            },
            inputIsSwitchedCUS1(_field){
                // if(_filed.isSwitchedCUS1){
           
                //     // check exist
                //     const tmpCheck = this.columnsCUS1.find(dat=>dat.field == _filed.key)
                //     if(!tmpCheck){
                //         // console.log("not exist",tmpCheck.field) 
                //         this.columnsCUS1.push( { field: _filed.key, label: _filed.label ,centered : true, headerClass: "is-sticky-column-one", width : 50 , "uuid" : null } )
                //         // revise uuid
                //         this.revisedUUID_columnsCUS1() 
                //     }
                     
                     
             
                // }else{
                // this.removeColumn(_filed.key,false) 
                // // revise uuid
                // //this.revisedUUID_columnsCUS1() 
                // }

                console.log(_field)
            },
            makeAllColumn(_columnsCUS){
                _columnsCUS.splice(3) 
                let _idx = 3
                this.dataLabParamsMaster.forEach(dat=>{
                    dat.isSwitchedCUS1 = true
                    _columnsCUS.push( { field: dat.key, label: dat.label ,centered : true, headerClass: "is-sticky-column-one", width : 50 , "uuid" : _idx } )
                   _idx++
               })
            },
            removeColumn(_column_field){
               const tmp =  this.dataLabParamsMaster.find(dat=>dat.key ==  _column_field)
            //    console.log("tmp",tmp)
               if(tmp){
                tmp.isSwitchedCUS1 = false
               }   


            //   //   console.log("removeColumn ---> ",_column_field) 
            //     // remove in columnsCUS1
            //     const columnsCUS1_Tmp = this.columnsCUS1.find( dat=> dat.field == _column_field)
            //    //    console.log("columnsCUS1_Tmp--->",columnsCUS1_Tmp)  
            //    if(columnsCUS1_Tmp){      
            //    // console.log("found -->",columnsCUS1_Tmp)          
            //     const indexOfColumnsCUS1_Tmp  =  this.columnsCUS1.indexOf(columnsCUS1_Tmp)
            //    //-  console.log("found index-->",indexOfColumnsCUS1_Tmp)    
            //     this.columnsCUS1.splice(indexOfColumnsCUS1_Tmp,1) 
            //     }

            //     // change staus in dataLabParamsMaster
            //     if(changeStausIndataLabParamsMaster){
            //             const dataLabParamsMaster_Tmp = this.dataLabParamsMaster.find(dat=>dat.key == _column_field)
            //                             if(dataLabParamsMaster_Tmp){
            //                             //  console.log("found dataLabParamsMaster_Tmp-->",dataLabParamsMaster_Tmp)   
            //                                 dataLabParamsMaster_Tmp.isSwitchedCUS1 = false
            //             }
            //     }
                


            //     // revise uuid
            //     this.revisedUUID_columnsCUS1()
            },
            revisedUUID_columnsCUS1(){
                let _idx = 0
                this.columnsCUS1.forEach(dat=> {
                        dat.uuid = _idx
                    _idx++
                    })

            } ,
            makeColumn_V2(_userCustomizeCBCTbl,_cusColumn){
     
                _cusColumn.splice(3)
                
                
                 this.dataLabParamsMaster.forEach(dataMaster=>{
                     const tmp =   _userCustomizeCBCTbl.find(dataCustomize=>dataCustomize.key == dataMaster.key && dataCustomize.isSwitchedCUS1 ) 
                     if(tmp){
                         dataMaster.isSwitchedCUS1 = true
                         _cusColumn.push( { field: dataMaster.key, label: dataMaster.label ,centered : true, headerClass: "is-sticky-column-one", width : 50 }  )
                     }
                })


                // this.dataLabParamsMaster.forEach(dataMaster=>{
                //      const tmp =   _userCustomizeCBCTbl.find(dataCustomize=>dataCustomize.key == dataMaster.key ) 
                //      if(tmp){
                //          dataMaster.isSwitchedCUS1 = true
                //          _cusColumn.push( { field: dataMaster.key, label: dataMaster.label ,centered : true, headerClass: "is-sticky-column-one", width : 50 }  )
                //      }
                // })





                // _userCustomizeCBCTbl.forEach( (dataLabParam) => {
                //     _cusColumn.push( { field: dataLabParam.key, label: dataLabParam.label ,centered : true, headerClass: "is-sticky-column-one", width : 50 }  )
                // })
            },

            makeColumn(_userCustomizeCBCTbl,_cusColumn){
                _cusColumn.splice(3)
                _userCustomizeCBCTbl.forEach( (dataLabParam) => {
                    _cusColumn.push( { field: dataLabParam.key, label: dataLabParam.label ,centered : true, headerClass: "is-sticky-column-one", width : 50 }  )
                })
            },
            forceDetailEachLab(){
                
                if ((this.IDLABSelected.idlab !== null ) && (this.IDLABSelected.kind !== null)) {
                    this.tabOPDSpace = 1
                    this.$refs.btnRefreshLN.$el.click()
                } 
            },


        },
        data() {
            return {
                    ismobileOrNot : false ,
                    chartXAxis : [],  // ['idlab','idlab','idlab',...]
                    chartYAxis : [], //  [ {'label':'' , 'key':''} , {'label':'' , 'key':''} , ... ]
                    arrTblDataChart : [] ,
                    arrColumnsChart : [],
                    chkRowsTblChart : [],
                    isBtnRefreshCBC : false,
                    dataCBCSpecLN:null,
                    dataCytoSpecLN : DATACYTOSPECLN_MODEL,
                    // dataCytoSpecLN:{ "dat_prepare": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "dat_ct": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "img": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "diag_code": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "status": { "id": "", "name": "" }, "assigned_to_user": { "id": "", "name": "" } , "data_req" : [] },
                    dataBiopsySpecLN: DATABIOPSPECLN_MODEL,
                    dataPCRSpecLN: DATA_PCR_LN_MODEL,
                    dataBACTSpecLN: DATA_BACT_LN_MODEL,
                    dataPARASpecLN: DATA_PARA_LN_MODEL,
                    dataORGASpecLN: DATA_ORGA_LN_MODEL,
                    dataNecropsySpecLN: DATANECROPSPECLN_MODEL,
                    // dataBiopsySpecLN: { "dat_prepare": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "dat_ct": { "dat": "", "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "img": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "diag_code": { "dat": [], "user_rec": "", "avartar": "", "date_rec": "", "time_rec": "" }, "status": { "id": "", "name": "" }, "assigned_to_user": { "id": "", "name": "" } , "data_req" : [] },
                    // dataDiseaseCodeWithLN:null,
                    dataRawCBC:[],
                    columnsCUS1: [{ field: 'idlab', label: 'LAB ID' ,width : 40 , sticky: true,  headerClass: "is-sticky-column-two",  cellClass: "is-sticky-column-two" , "uuid": 0} ,
                        { field: 'date_req', label: 'Date',width : 120 , "uuid": 1 } ,
                        { field: 'time_req', label: 'Time' ,width : 60 , "uuid": 2 } ,
                        // { field: 'hm_hgb', label: 'HGB' , } ,
                        // { field: 'hm_pcv', label: 'PCV' } ,
                    ],
                    columnsCUS2: [{ field: 'idlab', label: 'LAB ID' ,width : 40 } ,
                        { field: 'date_req', label: 'Date' ,width : 120} ,
                        { field: 'time_req', label: 'Time',width : 60 } ,
                        // { field: 'hm_hgb', label: 'HGB' , } ,
                        // { field: 'hm_pcv', label: 'PCV' } ,
                    ],
                    columnsCUS3: [{ field: 'idlab', label: 'LAB ID' ,width : 40} ,
                        { field: 'date_req', label: 'Date',width : 120 } ,
                        { field: 'time_req', label: 'Time' ,width : 60} ,
                        // { field: 'hm_hgb', label: 'HGB' , } ,
                        // { field: 'hm_pcv', label: 'PCV' } ,
                    ],
                    // selected : null,
                    isEmpty: false,
                    isBordered: true,
                    isStriped: true,
                    isNarrowed: false,
                    isHoverable: true,
                    isFocusable: true,
                    hasMobileCards: true,
                    isLoading: false,
                    tabOPDSpace : 0 ,
                    labcbclist_spec_opdno : [],
                    isTblTotalCBCLoading : false,
                    currentPage : 1,
                    perPage : 5,
                    // totalLabCount : 0,

                   // imrCount : 0,
                   isFullScreenLoading: false,

                   // chart cbc
                   triggerChange:true,
                   datacollectionToChart :
                       {
                         labels: [],
                         datasets:[]
                    },

                  options : {
                    // responsive: true,
                    // maintainAspectRatio: false,
                    tooltips: {
                        mode : 'nearest',
                        intersect : false
                    }
                   },


                   docKindSelected : '',

                   isCytoShowing : false,

                   testTags : ['sDFzsdf','SDFzsdfzsdf','dfgsegsegtrear'],
                   modeSearchOPD : 0,  // 0 ---> normal , 1 ---> ForManualLabAutomate


                   stickyHeader : true,
                   isSwitchedCusColumn : false,
                   isSwitchedChartRawCBC : false,
                   tblRawCBCperPage : 10,
                   currentPage_tblRawCBCperPage : 1,
                   tblDataLabParamsMasterperPage : 10,
                   currentPage_tblDataLabParamsMasterperPage : 1,

                //    checkboxGroupIDLAB :[],

                   tbldataRawCBCPerPage : 10,
                   currentPage_tbldataRawCBCPerPage : 1,


                   searchTxtParam: "",
                   paginatedLABIDTblMode : true,


                   isSortCBCTableShowing : false,
                   //    cusNoToChild : "cus0",// "cus0", "cus1" ,"cus2"

                   isBtnViewCBCAsPDFTablesData : false,

                   isDlgSelectGrpLABForViewTableShowing : false, 


                   cusNoToChild :{
                        "cus0" : "cus0" ,
                        "cus1" : "cus1" ,
                        "cus2" : "cus2" ,
                    },





                    isSearchSomeTextInLabShowing : false,
                    isSearchLabbyLabIDShowing : false,
            }
        } ,
        watch:{
            chartXAndChartYChange:{
                handler: function (val) {
                    if ((val.chartXAxis.length>0)&&(val.chartYAxis.length>0)){
                        // console.log('X : '+val.chartXAxis)    // idlab
                        // console.log('Y : ' +val.chartYAxis)   // key ==> cbc ==== datasets --> hm_hgb,hm_pcv,hm_lymph,hm_segs...
                        // console.log(this.dataRawCBC)



                        this.arrColumnsChart = [  // clear data columns table
                            { title: 'Lab No', field: 'idlab', visible: true },
                            { title: 'Date', field: 'date_req', visible: true },
                            { title: 'Time', field: 'time_req', visible: true },
                        ]


                        // console.log(this.arrColumnsChart)
                        this.dataLabParamsMaster.forEach( (dataParams,idxDataParams,arrDataParams) => {
                            if(arrDataParams[idxDataParams].isNumberic){
                                this.arrColumnsChart.push({
                                                    title: arrDataParams[idxDataParams].label ,
                                                    field: arrDataParams[idxDataParams].key ,
                                                    visible: false
                                                })
                            }
                        })


                        // copy new array for IdLab ---> arrIDLab from val.chartXAxis
                        const arrIDLab =[]
                        val.chartXAxis.forEach(dat => {
                            arrIDLab.push(dat)
                        })
                        // sort arrIDLab
                        // sort(arrIDLab).desc()
                        sort(arrIDLab).asc()
                        // console.log("arrIDLab")
                        // console.log(arrIDLab)
                        // arrIDLab.sort(function(a, b){return b-a})
                        // create dataset
                        var datasetsTemp = []

                        // for(var labKey =0 ; labKey < val.chartYAxis.length ; labKey++){
                        val.chartYAxis.forEach((datKey,idxLabKey,arrLabKey) => {


                                //**********************************************************
                                var dataTemp = []
                                this.arrTblDataChart = []
                                // for(var idlab=0; idlab < arrIDLab.length; idlab++){
                                 arrIDLab.forEach( (datArrIDLab,idxArrIDLab,_arrIDLab) =>{

                                        this.dataRawCBC.forEach((datDataRawCBC,idxDataRawCBC,arrDataRawCBC) =>{
                                            const keyName =  arrLabKey[idxLabKey] // val.chartYAxis[labKey]

                                            if(arrDataRawCBC[idxDataRawCBC].idlab === _arrIDLab[idxArrIDLab] ){
                                                // for display into tblChart
                                                this.arrTblDataChart.unshift(this.dataRawCBC[idxDataRawCBC])
                                                // this.arrTblDataChart.push(this.dataRawCBC[idxDataRawCBC])
                                                // for display into Chart
                                                if( arrDataRawCBC[idxDataRawCBC][keyName]){
                                                  //  dataTemp.unshift( arrDataRawCBC[idxDataRawCBC][keyName])
                                                     dataTemp.push( arrDataRawCBC[idxDataRawCBC][keyName])
                                                }else{
                                                    //dataTemp.unshift(null)
                                                     dataTemp.push(null)
                                                }
                                            }
                                        })


                                 })

                                //**********************************************************
                            // datasetsTemp.unshift({
                            //     label : this.labelParamsLabByKey[idxLabKey],
                            //     backgroundColor: getRgbaColor(idxLabKey),
                            //     // borderColor: getLightColor(labKey),
                            //     borderColor:getHardColor(idxLabKey),
                            //     pointBackgroundColor: getHardColor(idxLabKey),
                            //     borderWidth: 5,
                            //     pointBorderColor: getHardColor(idxLabKey),
                            //     data: dataTemp,
                            // })
                                datasetsTemp.push({
                                    label : this.labelParamsLabByKey[idxLabKey],
                                    backgroundColor: getRgbaColor(idxLabKey),
                                    // borderColor: getLightColor(labKey),
                                    borderColor:getHardColor(idxLabKey),
                                    pointBackgroundColor: getHardColor(idxLabKey),
                                    borderWidth: 5,
                                    pointBorderColor: getHardColor(idxLabKey),
                                    data: dataTemp,
                                })

                            // console.log(JSON.stringify(dataTemp))

                            this.arrColumnsChart.forEach((dat,index,arr)=>{
                                // console.log(index+'   ' +dat.field +'   '+dat.title+'  '+dat.visible)
                                if(dat.field === val.chartYAxis[idxLabKey]){
                                    arr[index].visible = true
                                }

                            })


                        })


                        // push dataset into chart

                        // console.log("datasetsTemp" )
                        // console.log(JSON.stringify(datasetsTemp))
                        //  console.log(" displayDateTimeByIdlabMixStrInArr")
                        //  console.log(JSON.stringify(this.displayDateTimeByIdlabMixStrInArr))


                        this.datacollectionToChart.labels = this.displayDateTimeByIdlabMixStrInArr
                        this.datacollectionToChart.datasets = datasetsTemp
                        this.triggerChange = !this.triggerChange


                        // console.log('datacollection')
                        // console.log(JSON.stringify(this.datacollectionToChart))

                        // console.log('options')
                        // console.log(JSON.stringify(this.options))

                        //
                        // this.$refs.LineChart_1.datacollection =
                        //     {
                        //          labels: this.displayDateTimeByIdlabMixStrInArr,
                        //          datasets: datasetsTemp
                        //     }
                        // this.$refs.LineChart_1.options = {
                        //     tooltips: {
                        //         mode : 'nearest',
                        //         intersect : false
                        //     }
                        // }




                    }
                },
                deep : true
            },
        }

    }
</script>

<style >
    /* img {
        opacity: 0.5;
        width: 80px;
        height: 80px;
    } */

    #hemato{
        color: mediumvioletred;
    }
    #blchem{
       color: cornflowerblue;
    }

    tr.is-info1 {
        background: #167df0;
        color: #fff;
    }


    .is-sticky-column-one {
    background: #edeeee !important;
    color: rgb(67, 127, 154) !important;
    }


    .is-sticky-column-two {
        background: #167df0 !important;
        color: white !important;
    }
    
    .checkbox-container {
  display: flex;
  flex-wrap: wrap;
}

.b-checkbox-button {
  flex-basis: 5%;
  /* Adjust the width based on your preference */
  /* For 5 elements per row, each checkbox will occupy 20% of the container's width */
}

</style>